var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-700 h-full pt-4 lg:flex lg:flex-col lg:items-center lg:justify-center"},[_c('dashboard-notification-list',{staticClass:"md:w-2/3 3xl:w-1/2",attrs:{"on-touch-interface":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }